import React, { FC, useEffect, useState } from 'react';
import { FlowStep } from '$models';
import { GiftShopFlow } from './components';
import { useAppEvents, useTranslation } from '$hooks';
import { SidePanel } from '$components/elements/side-panel';

type Props = {
    open?: boolean;
    itemNumber?: string;
    editStep?: string | FlowStep;
    setOpen?: (open: boolean) => void;
};

export const GiftShop: FC<Props> = (props: Props): JSX.Element => {
    const { editStep, itemNumber, open, setOpen } = props;
    const { translate } = useTranslation();
    const { onToggleModal } = useAppEvents();
    const [modalInit, setModalInit] = useState(false);

    useEffect(() => {
        if (!modalInit) {
            setModalInit(true);
            if (open) {
                onToggleModal(open);
            }
        } else {
            onToggleModal(open);
        }
    }, [open]);

    return (
        <SidePanel show={open} onChange={setOpen} title={translate('giftShop.delivery.send')}>
            <GiftShopFlow itemNumber={itemNumber} editStep={editStep} onCloseModal={() => setOpen?.(false)} />
        </SidePanel>
    );
};
